import { ModelFactory } from "../../../ModelFactory";

export class WebserverInfo {
  constructor(
    public readonly component: 'apache' | 'nginx',
  ) {
  }
}

export const webserverConfigExamples: Record<WebserverInfo['component'], string> = {
  apache: 'Header always set X-Frame-Options "SAMEORIGIN"',
  nginx: 'add_header X-Frame-Options "SAMEORIGIN";',
}

class WebserverInfoFactory extends ModelFactory<WebserverInfo> {
  protected fromJson(json: any): WebserverInfo {
    return new WebserverInfo(
      json['component'],
    );
  }
}
export const webserverInfoFactory = new WebserverInfoFactory();
